import React, { useMemo, useState } from "react";

import {
  faTrophy,
  faFire,
  faBolt,
  faRankingStar,
  faUsers,
  faMedal,
  faStar,
  faShareNodes,
  faDownload,
  faComment,
  faHeart,
  faBookmark,
  faArrowTrendUp,
  faCircleCheck,
  faLightbulb,
  faGlobe,
  faLocationDot,
  faVideo,
  faImage,
  faHandsClapping,
  faBullhorn,
  faCrown,
  faRocket,
  faUserPlus,
  faCalendarCheck,
  faAward,
  faQuoteLeft,
  faPeopleGroup,
  faChartLine,
  faThumbsUp,
  faShieldHeart,
  faClock,
  faSeedling,
  faGraduationCap,
  faBriefcase,
  faPersonRunning,
  faLaptopCode,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import QRCode from "react-qr-code";

const AchieversHome = () => {

  const [activeTab, setActiveTab] = useState("today");

  /* =========================================================
      USER
  ========================================================= */

  const user = {
    name: "Rahul Verma",
    achieverCode: "ACH-2941",
    applauseReceived: 18420,
    inspirationScore: 92,
    impactScore: 81,
    streak: 16,
    rank: 5,
    achievements: 28,
    level: "Community Trailblazer",
  };

  /* =========================================================
      FILTER TABS
  ========================================================= */

  const tabs = [
    "today",
    "week",
    "month",
    "trending",
    "top",
    "women",
    "students",
    "heroes",
  ];

  /* =========================================================
      STATS
  ========================================================= */

  const stats = [
    {
      title: "Applause",
      value: "18.4K",
      icon: faHandsClapping,
      color: "border-pink-500",
      text: "Recognition received",
    },
    {
      title: "Impact Score",
      value: user.impactScore,
      icon: faUsers,
      color: "border-green-500",
      text: "Community influence",
    },
    {
      title: "Inspiration",
      value: user.inspirationScore,
      icon: faLightbulb,
      color: "border-yellow-500",
      text: "People inspired",
    },
    {
      title: "Achievements",
      value: user.achievements,
      icon: faMedal,
      color: "border-cyan-500",
      text: "Published stories",
    },
    {
      title: "Streak",
      value: `${user.streak} Days`,
      icon: faFire,
      color: "border-orange-500",
      text: "Recognition streak",
    },
  ];

  /* =========================================================
      FEATURED ACHIEVERS
  ========================================================= */

  const featured = [
    {
      id: 1,
      name: "Anjali Mehta",
      category: "Women In STEM",
      title: "Built AI-Based Rural Health Monitoring Platform",
      applause: 8420,
      comments: 921,
      impact: "Helping early detection in remote villages.",
      badge: "Trailblazer",
      location: "Mumbai",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1200&auto=format&fit=crop",
    },
    {
      id: 2,
      name: "Rohit Sharma",
      category: "Student Innovation",
      title: "Created Solar-Powered Smart Study Desk",
      applause: 5230,
      comments: 402,
      impact: "Affordable learning solution for students.",
      badge: "Youth Icon",
      location: "Pune",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1200&auto=format&fit=crop",
    },
  ];

  /* =========================================================
      ACHIEVEMENT FEED
  ========================================================= */

  const achievements = [
    {
      id: 1,
      category: "Startup",
      achiever: "Karan Bedi",
      title: "Scaled local food startup to 50,000 customers",
      description:
        "Started from a single cloud kitchen and now serving across 6 cities.",
      why:
        "Encourages local entrepreneurship and employment generation.",
      applause: 5200,
      comments: 318,
      inspired: 2400,
      badge: "Community Pride",
      trending: true,
      time: "2 hrs ago",
      icon: faRocket,
    },
    {
      id: 2,
      category: "Women Empowerment",
      achiever: "Neha Kapoor",
      title: "Trained 800 women in financial literacy",
      description:
        "Conducted workshops for women entrepreneurs and homemakers.",
      why:
        "Improves financial independence and social confidence.",
      applause: 7120,
      comments: 520,
      inspired: 3800,
      badge: "Women Of Impact",
      trending: true,
      time: "Today",
      icon: faShieldHeart,
    },
    {
      id: 3,
      category: "Education",
      achiever: "Aman Tiwari",
      title: "Won national robotics championship",
      description:
        "Represented his school at national-level innovation competition.",
      why:
        "Motivates students towards innovation and technology.",
      applause: 3800,
      comments: 240,
      inspired: 1600,
      badge: "Student Champion",
      trending: false,
      time: "Yesterday",
      icon: faGraduationCap,
    },
    {
      id: 4,
      category: "Fitness",
      achiever: "Ritika Shah",
      title: "Lost 32kg through disciplined transformation",
      description:
        "Inspired thousands through consistency and wellness journey.",
      why:
        "Promotes healthy lifestyle and mental resilience.",
      applause: 6400,
      comments: 611,
      inspired: 5200,
      badge: "Transformation Hero",
      trending: true,
      time: "3 hrs ago",
      icon: faPersonRunning,
    },
  ];

  /* =========================================================
      CHALLENGES
  ========================================================= */

  const challenges = [
    {
      id: 1,
      title: "Women In STEM Week",
      participants: 8200,
      reward: "Featured Recognition",
      icon: faLaptopCode,
    },
    {
      id: 2,
      title: "Local Hero Challenge",
      participants: 3200,
      reward: "Top Achiever Badge",
      icon: faPeopleGroup,
    },
    {
      id: 3,
      title: "Student Innovator Sprint",
      participants: 6100,
      reward: "Youth Icon Feature",
      icon: faGraduationCap,
    },
  ];

  /* =========================================================
      LEADERBOARD
  ========================================================= */

  const leaderboard = [
    {
      id: 1,
      name: "Anjali Mehta",
      rank: 1,
      applause: 28400,
    },
    {
      id: 2,
      name: "Rohit Sharma",
      rank: 2,
      applause: 22310,
    },
    {
      id: 3,
      name: "Neha Kapoor",
      rank: 3,
      applause: 21480,
    },
    {
      id: 4,
      name: "You",
      rank: 5,
      applause: 18420,
    },
  ];

  /* =========================================================
      COMMUNITY IMPACT
  ========================================================= */

  const community = [
    {
      id: 1,
      title: "Mentored 120 startup founders",
      icon: faBriefcase,
      impact: "+480 Inspiration Points",
    },
    {
      id: 2,
      title: "Organized free coding workshops",
      icon: faLaptopCode,
      impact: "+300 Community Impact",
    },
  ];

  /* =========================================================
      REFERRAL
  ========================================================= */

  const referralLink = `https://www.think5whys.com/achievers?ref=${user.achieverCode}`;

  const handleShare = async () => {

    const shareText = `
🏆 Think5Whys Achievers

Celebrate achievements that inspire people.

Referral Code: ${user.achieverCode}

${referralLink}
`;

    try {

      if (navigator.share) {

        await navigator.share({
          title: "Think5Whys Achievers",
          text: shareText,
          url: referralLink,
        });

      } else {

        await navigator.clipboard.writeText(shareText);

        alert("Referral copied!");

      }

    } catch (err) {
      console.log(err);
    }
  };

  const handleDownload = () => {
    window.print();
  };

  /* =========================================================
      FILTERED FEED
  ========================================================= */

  const filteredFeed = useMemo(() => {

    switch (activeTab) {
      case "women":
        return achievements.filter(
          (item) => item.category === "Women Empowerment"
        );

      case "students":
        return achievements.filter(
          (item) => item.category === "Education"
        );

      case "top":
        return [...achievements].sort(
          (a, b) => b.applause - a.applause
        );

      case "trending":
        return achievements.filter(
          (item) => item.trending
        );

      default:
        return achievements;
    }

  }, [activeTab]);

  return (

    <div className="min-h-screen bg-gradient-to-b from-[#07111f] via-[#0f1729] to-black text-white px-3 py-4">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="rounded-3xl overflow-hidden bg-gradient-to-r from-cyan-600 via-blue-700 to-indigo-800 shadow-2xl p-5">

        <div className="flex flex-col lg:flex-row gap-5 lg:items-center lg:justify-between">
          <div>
            <div className="flex flex-col justify-start">
                <div className="gap-2 bg-gray-500 text-white px-3 rounded-full text-xs mb-2 py-2">
                    <FontAwesomeIcon icon={faTrophy} />
                    Think5Whys Recognition Intelligence Platform
                </div>

                <h1 className="flex text-start text-xl lg:text-3xl font-black">
                🏆 Achievers
                </h1>

                <p className="mt-3 text-sm text-cyan-50 max-w-2xl">
                Celebrate real achievements, spotlight inspiring people, amplify community impact and transform applause into
                meaningful recognition stories across the Think5Whys ecosystem.
                </p>
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">🚀 Innovation</div>
              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">🌍 Community Impact</div>
              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">🎓 Student Achievers</div>
              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">👏 Applause Integrated</div>
            </div>
            <div className="flex flex-wrap gap-3 mt-5">
              <button
                type="button"
                className="w-48 lg:w-64 text-xs lg:text-sm bg-white text-black px-4 py-2 rounded-2xl font-semibold"
              >
                <FontAwesomeIcon icon={faMedal} />
                <span className="ml-2">Post Achievement</span>
              </button>
              <button
                type="button"
                className="w-48 lg:w-64 text-xs lg:text-sm bg-black/30 border border-white/20 px-4 py-2 rounded-2xl font-semibold"
              >
                <FontAwesomeIcon icon={faHandsClapping} />
                <span className="ml-2">Import From Applause</span>
              </button>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-4">
            <QRCode
              value={referralLink}
              size={130}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mt-4">
        {stats.map((item, index) => (
          <div
            key={index}
            className={`bg-[#121d31] ${item.color} border rounded-3xl p-4`}
          >
            <div className="flex items-center justify-between">
              <FontAwesomeIcon
                icon={item.icon}
                className="text-cyan-300 text-xl"
              />
              <span className="text-xs text-cyan-100">
                {item.title}
              </span>
            </div>
            <h2 className="text-3xl font-black mt-3 text-yellow-200">
              {item.value}
            </h2>
            <p className="text-xs text-gray-300 mt-1">
              {item.text}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold text-cyan-200">
            <FontAwesomeIcon
              icon={faStar}
              className="mr-2 text-cyan-300"
            />
            Featured Achievers
          </h3>
          <div className="text-xs text-gray-400">
            Stories inspiring communities
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {featured.map((item) => (
            <div
              key={item.id}
              className="bg-[#121d31] rounded-3xl overflow-hidden border border-[#23344f]"
            >
              <img
                src={item.image}
                alt={item.name}
                className="h-56 w-full object-cover"
              />
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <div className="bg-cyan-500/20 text-cyan-300 text-xs px-3 py-1 rounded-full">
                    {item.category}
                  </div>
                  <div className="bg-yellow-500/20 text-yellow-300 text-xs px-3 py-1 rounded-full">
                    {item.badge}
                  </div>
                </div>
                <h2 className="text-xl font-bold mt-4">{item.title}</h2>
                <p className="text-sm text-gray-300 mt-3 leading-relaxed">
                  {item.impact}
                </p>

                <div className="flex items-center gap-5 mt-5 text-sm">
                  <div className="flex items-center gap-2 text-pink-300">
                    <FontAwesomeIcon icon={faHandsClapping} />
                    {item.applause}
                  </div>
                  <div className="flex items-center gap-2 text-cyan-300">
                    <FontAwesomeIcon icon={faComment} />
                    {item.comments}
                  </div>
                  <div className="flex items-center gap-2 text-green-300">
                    <FontAwesomeIcon icon={faLocationDot} />
                    {item.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5 flex gap-2 overflow-x-auto pb-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition ${
              activeTab === tab
                ? "bg-cyan-500 text-black font-bold"
                : "bg-[#121d31]"
            }`}
          >
            {tab === "today" && "Today"}
            {tab === "week" && "This Week"}
            {tab === "month" && "This Month"}
            {tab === "trending" && "Trending"}
            {tab === "top" && "Top Achievers"}
            {tab === "women" && "Women Of Impact"}
            {tab === "students" && "Students"}
            {tab === "heroes" && "Local Heroes"}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
        <div className="lg:col-span-2 space-y-4">
          {filteredFeed.map((item) => (
            <div
              key={item.id}
              className="bg-[#121d31] rounded-3xl border border-[#23344f] p-4"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3">
                  <div className="w-14 h-14 rounded-2xl bg-cyan-500/20 flex items-center justify-center">
                    <FontAwesomeIcon
                      icon={item.icon}
                      className="text-cyan-300 text-xl"
                    />
                  </div>
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <div className="bg-cyan-500/20 text-cyan-300 text-xs px-2 py-1 rounded-full">
                        {item.category}
                      </div>
                      <div className="bg-yellow-500/20 text-yellow-300 text-xs px-2 py-1 rounded-full">
                        {item.badge}
                      </div>
                      {item.trending && (
                        <div className="bg-pink-500/20 text-pink-300 text-xs px-2 py-1 rounded-full">
                          🔥 Trending
                        </div>
                      )}
                    </div>
                    <h2 className="text-lg font-bold mt-3">{item.title}</h2>
                    <p className="text-sm text-gray-300 mt-2 leading-relaxed">{item.description}</p>
                    <div className="bg-[#1a2942] rounded-2xl p-3 mt-4">
                      <div className="flex items-center gap-2 text-yellow-300 text-sm font-semibold mb-2">
                        <FontAwesomeIcon icon={faLightbulb} />
                        Why This Matters
                      </div>
                      <p className="text-sm text-gray-300 leading-relaxed">
                        {item.why}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-xs text-gray-400 whitespace-nowrap">
                  <FontAwesomeIcon icon={faClock} className="mr-1" />
                  {item.time}
                </div>
              </div>
              <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 mt-5">
                <button
                  type="button"
                  className="bg-pink-500/10 hover:bg-pink-500/20 py-2 rounded-2xl text-sm"
                >
                  👏 {item.applause}
                </button>
                <button
                  type="button"
                  className="bg-cyan-500/10 hover:bg-cyan-500/20 py-2 rounded-2xl text-sm"
                >
                  💬 {item.comments}
                </button>
                <button
                  type="button"
                  className="bg-yellow-500/10 hover:bg-yellow-500/20 py-2 rounded-2xl text-sm"
                >
                  ✨ {item.inspired}
                </button>
                <button
                  type="button"
                  className="bg-[#1a2942] hover:bg-[#223553] py-2 rounded-2xl text-sm"
                >
                  <FontAwesomeIcon icon={faShareNodes} />
                </button>
                <button
                  type="button"
                  className="bg-[#1a2942] hover:bg-[#223553] py-2 rounded-2xl text-sm"
                >
                  <FontAwesomeIcon icon={faBookmark} />
                </button>
                <button
                  type="button"
                  className="bg-[#1a2942] hover:bg-[#223553] py-2 rounded-2xl text-sm"
                >
                  <FontAwesomeIcon icon={faBullhorn} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-4">
          <div className="bg-[#121d31] rounded-3xl border border-[#23344f] p-4">
            <h3 className="text-lg font-bold text-yellow-200 mb-4">
              <FontAwesomeIcon
                icon={faRankingStar}
                className="mr-2 text-yellow-300"
              />
              Top Achievers
            </h3>
            <div className="space-y-3">
              {leaderboard.map((item) => (
                <div
                  key={item.id}
                  className={`rounded-2xl p-3 flex items-center justify-between ${
                    item.name === "You"
                      ? "bg-cyan-500/20 border border-cyan-400"
                      : "bg-[#1a2942]"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-black/20 flex items-center justify-center">
                      {item.rank === 1 ? (
                        <FontAwesomeIcon
                          icon={faCrown}
                          className="text-yellow-300"
                        />
                      ) : (
                        item.rank
                      )}
                    </div>
                    <div>
                      <h4 className="font-semibold text-sm">{item.name}</h4>
                      <p className="text-xs text-gray-400">Rank #{item.rank}</p>
                    </div>
                  </div>
                  <div className="font-bold text-pink-300">{item.applause}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#121d31] rounded-3xl border border-[#23344f] p-4">
            <h3 className="text-lg font-bold text-green-200 mb-4">
              <FontAwesomeIcon
                icon={faPeopleGroup}
                className="mr-2 text-green-300"
              />
              Community Impact
            </h3>
            <div className="space-y-3">
              {community.map((item) => (
                <div
                  key={item.id}
                  className="bg-[#1a2942] rounded-2xl p-3"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-2xl bg-green-500/20 flex items-center justify-center">
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="text-green-300"
                      />
                    </div>
                    <div>
                      <h4 className="font-semibold text-sm">{item.title}</h4>
                      <p className="text-xs text-green-300 mt-2">{item.impact}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#121d31] rounded-3xl border border-[#23344f] p-4">
            <h3 className="text-lg font-bold text-cyan-200 mb-4">
              <FontAwesomeIcon
                icon={faBolt}
                className="mr-2 text-cyan-300"
              />
              Achievement Challenges
            </h3>
            <div className="space-y-3">
              {challenges.map((challenge) => (
                <div
                  key={challenge.id}
                  className="bg-[#1a2942] rounded-2xl p-3"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-cyan-500/20 flex items-center justify-center">
                      <FontAwesomeIcon icon={challenge.icon} className="text-cyan-300"/>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-sm">{challenge.title}</h4>
                      <p className="text-xs text-gray-400 mt-2">👥 {challenge.participants} participants</p>
                      <p className="text-xs text-yellow-300 mt-2">🎁 {challenge.reward}</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="w-full mt-4 bg-cyan-500 hover:bg-cyan-600 text-black py-2 rounded-2xl font-semibold transition"
                  >
                    Join Challenge
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-pink-600 via-purple-700 to-indigo-700 rounded-3xl p-5">
            <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faUserPlus}
                className="text-white text-xl"
              />
            </div>
            <h2 className="text-xl font-bold mt-4">Nominate Someone Inspirational</h2>
            <p className="text-sm text-pink-50 mt-3 leading-relaxed">
              Recognize teachers, founders, students, creators, women leaders and local heroes making meaningful impact.</p>
            <button
              type="button"
              className="w-full mt-5 bg-white text-black py-3 rounded-2xl font-bold"
            >
              Nominate Achiever
            </button>
          </div>

          <div className="bg-[#121d31] rounded-3xl border border-[#23344f] p-4">
            <h3 className="text-lg font-bold text-cyan-200 mb-4">
              <FontAwesomeIcon
                icon={faShareNodes}
                className="mr-2 text-cyan-300"
              />
              Share Achievers
            </h3>
            <div className="bg-white rounded-3xl p-4 flex justify-center">
              <QRCode value={referralLink} size={180}/>
            </div>
            <div className="text-center mt-4">
              <p className="text-xs text-gray-400">Referral Code</p>
              <h2 className="text-2xl font-black text-yellow-300 mt-1">{user.achieverCode}</h2>
              <p className="text-xs text-gray-400 mt-2">Invite people to celebrate inspiring achievements.</p>
            </div>
            <div className="grid grid-cols-2 gap-2 mt-4">
              <button
                type="button"
                onClick={handleShare}
                className="bg-cyan-500 hover:bg-cyan-600 text-black py-2 rounded-2xl font-semibold transition"
              >
                <FontAwesomeIcon icon={faShareNodes} />
                <span className="ml-2">Share</span>
              </button>
              <button
                type="button"
                onClick={handleDownload}
                className="bg-indigo-500 hover:bg-indigo-600 py-2 rounded-2xl font-semibold transition"
              >
                <FontAwesomeIcon icon={faDownload} />
                <span className="ml-2">Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 text-center text-xs text-gray-500 pb-6">© 2026 Achievers • Think5Whys Recognition Intelligence Platform</div>
    </div>
  );
};

export default AchieversHome;